import * as React from "react";
import classnames from "classnames";
import { Text } from "@grandvisionhq/elements";
/* empty css                                 */
const PrescriptionInformationLink = ({ children, className }) => {
  return /* @__PURE__ */ React.createElement(Text, { variant: "link", className: classnames("prescription-information-link", className) }, children);
};
export {
  PrescriptionInformationLink
};
//# sourceMappingURL=PrescriptionInformationLink.js.map
